module.exports = __webpack_public_path__ + "explore/images/eoy/rainbow.8928ea8f025108b2ee0d49027ebe8eda.png";